<template>
	<BaseButton :size="size" :type="type" :colors="style" :grouped="grouped">
		<slot/>
	</BaseButton>
</template>
<script setup lang="ts">
import {computed, defineProps} from 'vue'
import {Color} from '@/Types/Enums/Color'
import {ButtonType} from '@/Types/Enums/ButtonType'
import {ButtonSize} from '@/Types/Enums/ButtonSize'
import BaseButton from '@/Components/UI/Buttons/BaseButton.vue'

const props = defineProps<{
	color:Color,
	type?:ButtonType,
	size?:ButtonSize,
	grouped?:boolean,
}>()

const style = computed(():string => {
	const base = 'text-gray-500 border-transparent'
	switch(props.color){
		case Color.TrueAArEII:
			return `${base} hover:text-true-aareii-600 dark:hover:text-true-aareii-800`
		case Color.Red:
			return `${base} hover:text-red-600 dark:hover:text-red-800`
		case Color.Orange:
			return `${base} hover:text-orange-600 dark:hover:text-orange-800`
		case Color.Amber:
			return `${base} hover:text-amber-600 dark:hover:text-amber-800`
		case Color.Yellow:
			return `${base} hover:text-yellow-600 dark:hover:text-yellow-800`
		case Color.Lime:
			return `${base} hover:text-lime-600 dark:hover:text-lime-800`
		case Color.Green:
			return `${base} hover:text-green-600 dark:hover:text-green-800`
		case Color.Emerald:
			return `${base} hover:text-emerald-600 dark:hover:text-emerald-800`
		case Color.Teal:
			return `${base} hover:text-teal-600 dark:hover:text-teal-800`
		case Color.Cyan:
			return `${base} hover:text-cyan-600 dark:hover:text-cyan-800`
		case Color.Sky:
			return `${base} hover:text-sky-600 dark:hover:text-sky-800`
		case Color.Blue:
			return `${base} hover:text-blue-600 dark:hover:text-blue-800`
		case Color.Indigo:
			return `${base} hover:text-indigo-600 dark:hover:text-indigo-800`
		case Color.Violet:
			return `${base} hover:text-violet-600 dark:hover:text-violet-800`
		case Color.Purple:
			return `${base} hover:text-purple-600 dark:hover:text-purple-800`
		case Color.Fuchsia:
			return `${base} hover:text-fuchsia-600 dark:hover:text-fuchsia-800`
		case Color.Pink:
			return `${base} hover:text-pink-600 dark:hover:text-pink-800`
		case Color.Rose:
			return `${base} hover:text-rose-600 dark:hover:text-rose-800`
		case Color.Slate:
			return `${base} hover:text-slate-600 dark:hover:text-slate-800`
		case Color.Gray:
			return `${base} hover:text-gray-600 dark:hover:text-gray-800`
		case Color.Zinc:
			return `${base} hover:text-zinc-600 dark:hover:text-zinc-800`
		case Color.Stone:
			return `${base} hover:text-stone-600 dark:hover:text-stone-800`
		case Color.Neutral:
		default:
			return `${base} hover:text-neutral-600 dark:hover:text-neutral-800`
	}
})
</script>
